import { CreditCard, X, Zap, Flame, Leaf, ClipboardCheck } from "lucide-react";

const CREDIT_INFO = {
  electrical: { label: "Electrical", price: "£5", amount: "20 credits", color: "#00A3E0", bg: "#E8F7FC", Icon: Zap },
  mcs: { label: "MCS", price: "£5", amount: "20 credits", color: "#22C55E", bg: "#EAFBF0", Icon: Leaf },
  pat: { label: "PAT", price: "£5", amount: "10 credits", color: "#8B5CF6", bg: "#F3EFFE", Icon: ClipboardCheck },
  gas: { label: "Gas Safe", price: "£5", amount: "50 credits", color: "#EF4444", bg: "#FEECEC", Icon: Flame },
};

export default function BuyCreditsModal({ open, onClose, creditType, onBuy }) {
  if (!open) return null;
  const info = CREDIT_INFO[creditType] || CREDIT_INFO.electrical;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center" data-testid="buy-credits-modal">
      <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" onClick={onClose} />
      <div className="relative w-full max-w-sm mx-4 bg-white rounded-2xl p-6 animate-fade-in-up" style={{ boxShadow: '0 20px 60px rgba(0,0,0,0.15)' }}>
        <button onClick={onClose} className="absolute top-4 right-4 text-[#C7C7CC] hover:text-[#8E8E93] transition-colors" data-testid="buy-credits-close">
          <X className="w-5 h-5" />
        </button>

        <div className="flex items-center gap-3 mb-5">
          <div className="w-12 h-12 rounded-full flex items-center justify-center" style={{ backgroundColor: info.bg }}>
            <info.Icon className="w-6 h-6" style={{ color: info.color }} />
          </div>
          <div>
            <p className="text-lg font-bold" style={{ fontFamily: 'Outfit, sans-serif', color: '#1C1C1E' }}>No {info.label} Credits</p>
            <p className="text-xs" style={{ color: '#8E8E93' }}>You need credits to generate this document</p>
          </div>
        </div>

        <div className="rounded-xl p-5 mb-5 text-center" style={{ backgroundColor: '#F5F5F7' }}>
          <p className="text-3xl font-bold" style={{ fontFamily: 'IBM Plex Mono, monospace', color: info.color }}>{info.amount}</p>
          <p className="text-sm mt-1" style={{ color: '#8E8E93' }}>for just {info.price}</p>
        </div>

        <button onClick={() => { onBuy(creditType); onClose(); }} data-testid="buy-credits-confirm"
          className="w-full flex items-center justify-center gap-2 text-base py-3 text-white font-semibold rounded-xl hover:opacity-90 transition-all"
          style={{ backgroundColor: info.color, fontFamily: 'Outfit, sans-serif' }}>
          <CreditCard className="w-4 h-4" /> Buy {info.amount} — {info.price}
        </button>

        <p className="text-[10px] text-center mt-3" style={{ color: '#C7C7CC' }}>
          Secure payment via Stripe. Credits never expire.
        </p>
      </div>
    </div>
  );
}
